export default [
  { title: 'Privacy Policy', to: '/privacy-policy', newTab: true },
];
